enum ContentsSettingType {
    NOTI = 'noti',
    PUSH = 'push'
}

export default ContentsSettingType;
